import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import {Context} from '../../../Context';
import CustomToolTip from '../../ToolTipInfoCustomMUI';
import Zoom from '@mui/material/Zoom';
import { ReactComponent as IconChevron } from '../assets/icons/icon-chevron.svg';
import { ReactComponent as IconHeart } from '../assets/icons/icon-heart.svg';

import styles from '../../../styles/aprt.module.scss';
import buttons_styles from '../../../styles/buttons.module.scss';

function ApartmentHeading({
	setApartmentViewInteractions,
}) {

	const { t } = useTranslation();
	const { 
		navigateToApartmentInDirectionHandler, 
		filteredApartmentData, 
		activeApartmentData,
		favoriteApartmentUUIDs,
		toggleFavoriteApartmentHandler,
	} = useContext(Context);

		const currentUuid = activeApartmentData.uuid;

	const isCurrentUuidInFavorites = favoriteApartmentUUIDs.includes(currentUuid);

	const numberOfFilteredApartments = filteredApartmentData ? filteredApartmentData.length : 0;

	const handleApartmentChange = (direction) => {
		navigateToApartmentInDirectionHandler(direction);
		setApartmentViewInteractions((prev) => ({
			...prev,
			selectedCompartmentInd: null,
	}));
	};

	return (
		activeApartmentData && (
							<div
					style={{
						maxWidth: '30rem',
						minWidth: '28.5rem',
						display: 'flex',
						justifyContent: 'space-between',
						paddingBottom: '0.5rem'
					}}
				>
			{/* <div className={styles.heading__block}>
									<h2 className={styles.heading__apartment}>
						{t('apartment_card')}
					</h2>
			</div> */}

			<div 
			// style={{marginLeft: '-3rem'}}
			className={styles.heading__block}>
				{/* <button
					className={styles.planButton}
					onClick={() => {
						handleApartmentChange(-1)
					}}
					disabled={numberOfFilteredApartments <= 1}
				>
					<IconChevron
						title="poprzedni lokal" //TODO: add to locales
						className={styles.planButton__icon}
						style={{ transform: 'rotate(180deg)' }}
					/>
				</button> */}
				<div className={styles.heading__container}>
					{/* <h2 className={styles.heading__apartment}> */}
					<h3 >
						{`${t('number')}:
						${activeApartmentData.id_original}`}
					</h3>
				</div>
				</div>
				<div 
				// className={styles.planButtons__container_second}
				>
									<CustomToolTip
										title={
											isCurrentUuidInFavorites
												? t('remove_from_favorites')
												: t('add_to_favorites')
										}
										slots={{
											transition: Zoom,
										}}
										arrow
									>
										<button
											className={`${buttons_styles['bim_button']} ${
												isCurrentUuidInFavorites ? buttons_styles['bim_button--selected'] : ''
											}`}
											onClick={() => toggleFavoriteApartmentHandler(currentUuid)}
										>
											<IconHeart
												// title={
												// 	isCurrentUuidInFavorites
												// 		? 'usuń z ulubionych'
												// 		: 'dodaj do ulubionych'
												// } //TODO: add to locales
												className={buttons_styles['bim_button__icon']}
											/>
										</button>
									</CustomToolTip>
									</div>
				{/* <button
					className={styles.planButton}
					onClick={() => {
						handleApartmentChange(1)
					}}
					disabled={numberOfFilteredApartments <= 1}
				>
					<IconChevron
						title="następny lokal" //TODO: add to locales
						className={styles.planButton__icon}
					/>
				</button> */}
			</div>
		)
	);
}

export default ApartmentHeading;
